import React, { Fragment} from "react";
import { connect } from "react-redux";
import {useLocation} from "react-router-dom";

import LookFeature from "./lookFeature/lookFeature";
import LookMainCategory from "./lookCategory/lookMainCategory";
import LookFeatureMobileHeader from "./lookFeature/lookFeatureMobileHeader";
import GroheCategoriesMenu from "../../grohe/groheNavigation/groheCategories/groheCategoriesMenu";
import LookCategoryHeader from "./lookCategory/lookCategoryHeader";
import LookMainSectionsMobileWizard from "./lookMainSectionsMobileWizard";
import {ROUTES} from "../../../../routes";
import {getFeatureIsLocked} from "../../../../misc/helpers";

const LookMainSectionsMobile = (props) => {

  const {lookOpened, lookActiveFeature, lookActiveCategory, windowHeight} = props;
  const location = useLocation();

  const showWizard = location && location.pathname && location.pathname.includes(ROUTES.wizard);

  const featureIsLocked = getFeatureIsLocked(lookActiveFeature);

  return (
    <Fragment>
      <section className={"lm-section" + (lookOpened && (!lookActiveFeature && !lookActiveCategory) && !showWizard ? " lm-section--visible" : "")}>
        <div className="lm-content lm-content--groups">
          <GroheCategoriesMenu showWizardItems={true}/>
        </div>
      </section>
      <section className={"lm-section" + (lookOpened && lookActiveCategory && !lookActiveFeature && !showWizard ? " lm-section--visible" : "")}>
        <header className="lm-header">
          <LookCategoryHeader/>
        </header>
        <LookMainCategory contentHeight={windowHeight - 40}/>
      </section>
      <section className={"lm-section" + (lookOpened && lookActiveFeature && !showWizard ? " lm-section--visible" : "")}>
        <header className={"lm-header" + (featureIsLocked ? " lm-header--locked" : "")}>
          <LookFeatureMobileHeader/>
        </header>
        <div className="lm-content lm-content--feature">
          <LookFeature/>
        </div>
      </section>
      <LookMainSectionsMobileWizard contentHeight={windowHeight - 88}/>
    </Fragment>
  )
};


const mapStateToProps = (store) => {
  const {windowWidth, windowHeight, isMobile} = store.serverState;

  const {lookExpanded, lookActiveFeature, lookActiveCategory, moreInfoOpened, lookOpened
    // lookAllWallsOpened
  } = store.lookState;
  const {lookRemovedCartItems} = store.cartState;
  const {isPhoneNumberValidated} = store.userState; // to update component when user is logged in

  return {
    isMobile,
    lookOpened,
    lookExpanded,
    windowWidth,
    windowHeight,
    lookActiveFeature,
    lookActiveCategory,
    moreInfoOpened,
    lookRemovedCartItems,
    isPhoneNumberValidated,
    // lookAllWallsOpened,
  };
};

const mapDispatchToProps = {

};

export default connect(mapStateToProps, mapDispatchToProps)(LookMainSectionsMobile)
